import { render, staticRenderFns } from "./CertCompaniesFilter.vue?vue&type=template&id=cb99d9e8&scoped=true&"
import script from "./CertCompaniesFilter.vue?vue&type=script&lang=js&"
export * from "./CertCompaniesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb99d9e8",
  null
  
)

export default component.exports